import React, { useEffect, useMemo } from "react";
import Routers from "./Routers";
import "./App.scss";
import { Provider, useSelector, useDispatch } from "react-redux";
import { store, persistor } from "./store/store";
import { ConfigProvider } from "antd";
// import "bootstrap/dist/js/bootstrap.bundle";
import "react-toastify/dist/ReactToastify.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { NotificationProvider } from "./NotificationContext";
import { PersistGate } from "redux-persist/integration/react";
import { checkProfileLockStatus } from "./store/slices/AuthSlice";

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// persistor.purge();

const Context = React.createContext({
  name: "Default",
});

// Component to check profile lock status on app initialization
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated && token) {
      dispatch(checkProfileLockStatus());
    }
  }, [isAuthenticated, token, dispatch]);

  return children;
};

const App = () => {
  useEffect(() => {
    console.log("APPHITTING");
  }, []);

  const contextValue = useMemo(() => ({ name: "Ant Design" }), []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#00b96b",
              // Must be a number: antd derives the smaller radii from it with
              // arithmetic, and a "2px" string turned the popover arrow's
              // clip-path into NaN, leaving a blunt square arrow everywhere.
              borderRadius: 2,
            },
          }}
        >
          <NotificationProvider>
            <Context.Provider value={contextValue}>
              <AppInitializer>
                <Routers />
              </AppInitializer>
            </Context.Provider>
          </NotificationProvider>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
